/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Exceptional_Planning_Copy_WarningInputs */



/**
* | output |
* | --- |
* | "This will overwrite the exceptional planning of the selected units." |
*
* @param {Air_Handler_Unit_Exceptional_Planning_Copy_WarningInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_exceptional_planning_copy_warning = /** @type {((inputs?: Air_Handler_Unit_Exceptional_Planning_Copy_WarningInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Exceptional_Planning_Copy_WarningInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("This will overwrite the exceptional planning of the selected units.")
	return /** @type {LocalizedString} */ ("Cette action écrasera le planning exceptionnel des équipements sélectionnés.")
});